document.addEventListener('DOMContentLoaded', function () {

  /* ===== CONTACT FORM VALIDATION ===== */
  const form = document.querySelector('.contact-form-wrapper form');

  if (form) {
    form.addEventListener('submit', function (e) {
      const name = document.getElementById('ContactFormName')?.value.trim();
      const email = document.getElementById('ContactFormEmail')?.value.trim();
      const message = document.getElementById('ContactFormMessage')?.value.trim();

      if (!name || name.length < 2) {
        alert('Please enter a valid name (at least 2 characters).');
        e.preventDefault();
        return;
      }

      const emailPattern = /^[^ ]+@[^ ]+\.[a-z]{2,}$/i;
      if (!email || !emailPattern.test(email)) {
        alert('Please enter a valid email address.');
        e.preventDefault();
        return;
      }

      if (!message || message.length < 10) {
        alert('Please enter a more detailed message (at least 10 characters).');
        e.preventDefault();
      }
    });
  }

  /* ===== FAQ ACCORDION ===== */
  const questions = document.querySelectorAll('.accordion-question');

  questions.forEach(question => {
    question.addEventListener('click', function () {
      const answer = this.nextElementSibling;
      const isOpen = this.classList.contains('active');

      // Close all
      questions.forEach(q => {
        q.classList.remove('active');
        q.nextElementSibling.style.maxHeight = null;
      });

      // Open selected
      if (!isOpen) {
        this.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* ===== SMOOTH SCROLL TO CONTACT ===== */
  const contactLinks = document.querySelectorAll('a[href="#contact"]');

  contactLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const target = document.getElementById('contact');
      if (!target) return;

      const offset = 20; // adjust if you have a sticky header
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    });
  });

  /* ===== SUCCESS MESSAGE DISAPPEAR AFTER 10 SECONDS ===== */
  const successMessage = document.querySelector('.form-success'); 

  if (successMessage) {
    // Optional: Adding transition for fade-out effect
    successMessage.style.transition = 'opacity 1s ease-in-out'; 
    // Set a timeout to hide the success message after 10 seconds
    setTimeout(function () {
      successMessage.style.opacity = '0'; // Fade the message out

      // After the fade-out is complete, remove the element from the DOM
      setTimeout(function () {
        successMessage.remove();
      }, 1000); 
    }, 10000); 
  }

});